import React, { useContext } from 'react'
import { AppContext } from '../../context/app'

const TipJarButton = ({
  tipJarButtonInfo,
  btnStyle = { bottom: '80px' },
  className = 'absolute  right-0 mx-2 ',
}) => {
  const { setTipJarModalLink } = useContext(AppContext)

  const getStyleValue = (key, defaultValue) => {
    if (!tipJarButtonInfo?.style_config[key]) {
      return defaultValue ? defaultValue : ''
    }
    return tipJarButtonInfo?.style_config[key]
  }

  return (
    <div className={`${className} `} style={{ ...btnStyle, zIndex: '50' }}>
      <button
        style={{
          fontSize: '12px',
          backgroundImage: `linear-gradient(to ${getStyleValue(
            'gradient',
            'left',
          )}, ${getStyleValue('primary_color', '#371b7a')} , ${getStyleValue(
            'secondary_color',
            '#371b7a',
          )} )`,
          color: getStyleValue('text_color', '#fff'),
          height: '34px',
        }}
        className={`border rounded-full px-4 `}
        onClick={() => {
          setTipJarModalLink(tipJarButtonInfo?.link)
        }}
      >
        {tipJarButtonInfo?.placeholder}
      </button>
    </div>
  )
}

export default TipJarButton
